/**
 * KolsDB 인플루언서 행 → Apify 수집에 필요한 (platform, handle) 변환 유틸.
 */

/** 앱의 platformType 문자열 → apifyMetrics 플랫폼 키 */
export function toApifyPlatform(raw) {
  const s = String(raw || '').toLowerCase();
  if (s.includes('insta')) return 'instagram';
  if (s.includes('tiktok') || s.includes('tik tok') || s === 'tt') return 'tiktok';
  if (s.includes('youtube') || s === 'yt') return 'youtube';
  if (s === 'x' || s.includes('twitter')) return 'x';
  if (s.includes('facebook') || s === 'fb') return 'facebook';
  if (s.includes('xiaohongshu') || s.includes('샤오홍슈') || s.includes('小红书')) return 'xiaohongshu';
  if (s.includes('lemon8')) return 'lemon8';
  return null;
}

// URL 도메인 → apifyMetrics 플랫폼 키. 여러 플랫폼 URL을 한꺼번에 붙여넣었을 때
// (예: 여러 명 추가하기에 IG 링크와 TikTok 링크가 섞여 있는 경우) 줄마다 실제 URL이
// 가리키는 플랫폼으로 자동 판별하기 위함 — 선택해둔 플랫폼 탭 하나로 전부 밀어붙이면
// 다른 플랫폼 링크는 엉뚱하게 처리된다.
const DOMAIN_PLATFORM_PATTERNS = [
  { re: /instagram\.com/i, platform: 'instagram' },
  { re: /tiktok\.com/i, platform: 'tiktok' },
  { re: /youtube\.com|youtu\.be/i, platform: 'youtube' },
  { re: /(?:^|\/\/|\.)x\.com|twitter\.com/i, platform: 'x' },
  { re: /facebook\.com|fb\.com/i, platform: 'facebook' },
  { re: /xiaohongshu\.com|xhslink\.com/i, platform: 'xiaohongshu' },
  { re: /lemon8-app\.com/i, platform: 'lemon8' },
];

/** 입력값이 URL이면 도메인으로 플랫폼을 추정, 아니면 null(=선택된 플랫폼 탭 사용) */
export function detectPlatformFromUrl(input) {
  if (!input) return null;
  const s = String(input).trim();
  const found = DOMAIN_PLATFORM_PATTERNS.find((d) => d.re.test(s));
  return found ? found.platform : null;
}

/** 프로필 URL 에서 핸들 추출 (마지막 경로 세그먼트, @ 제거) */
export function handleFromUrl(url) {
  if (!url) return '';
  let h = String(url).trim();
  try {
    if (!/^https?:\/\//i.test(h)) h = `https://${h}`;
    const u = new URL(h);
    const parts = u.pathname.split('/').filter(Boolean);
    const skip = new Set(['p', 'reel', 'reels', 'video', 'status', 'watch', 'channel', 'c', 'user']);
    const found = parts.find((p) => !skip.has(p.toLowerCase()));
    return (found || parts[0] || '').replace(/^@/, '').trim();
  } catch {
    return h.replace(/^@/, '').trim();
  }
}

/** 인플루언서 행에서 수집용 핸들 결정 (profileId/username 우선, 없으면 URL 파싱) */
export function deriveHandle(influencer) {
  if (!influencer) return '';
  const p0 = influencer.platforms?.[0] || {};
  const direct = p0.profileId || p0.username || influencer.profileId;
  if (direct) return String(direct).replace(/^@/, '').trim();
  return handleFromUrl(influencer.profileUrl || p0.profileUrl || '');
}

/** apifyMetrics 플랫폼 키 → 인플루언서 등록 폼(백엔드 Platform enum) 값 */
const BACKEND_PLATFORM_MAP = {
  instagram: 'Instagram',
  tiktok: 'Tiktok',
  youtube: 'Youtube',
  x: 'X',
  facebook: 'Facebook',
  xiaohongshu: 'XHS',
  lemon8: 'Lemon8',
};
export function toBackendPlatform(apifyKey) {
  return BACKEND_PLATFORM_MAP[String(apifyKey || '').toLowerCase()] || null;
}
